import { Dialog as D } from "radix-ui";
import type { ReactNode } from "react";

export interface DialogProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  /** Кнопка, которая открывает диалог (Radix Trigger asChild). */
  trigger?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  /**
   * Кнопки подвала. Главная (variant="primary") на телефоне встаёт первой
   * строкой во всю ширину (docs/ui-rules.md, «8»).
   */
  footer?: ReactNode;
}

export function Dialog({ open, onOpenChange, trigger, title, description, children, footer }: DialogProps) {
  return (
    <D.Root open={open} onOpenChange={onOpenChange}>
      {trigger ? <D.Trigger asChild>{trigger}</D.Trigger> : null}
      <D.Portal>
        <D.Overlay className="w-dialog-overlay" />
        {/* Без описания Radix ждёт явный aria-describedby={undefined}, иначе предупреждает. */}
        <D.Content className="w-dialog" {...(description ? {} : { "aria-describedby": undefined })}>
          <D.Title className="w-dialog-title">{title}</D.Title>
          {description ? <D.Description className="w-dialog-description">{description}</D.Description> : null}
          {children}
          {footer ? <div className="w-dialog-footer">{footer}</div> : null}
        </D.Content>
      </D.Portal>
    </D.Root>
  );
}

/** Закрывает диалог: оборачивает кнопку подвала «Скасувати». */
export const DialogClose = D.Close;
